// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main{
    height: 100vh;
    width: 85%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}
.bottom_section{
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* ChatInput.css */
.chat-input-container {
  width: 90%;
  display: flex;
  align-items: center;
  padding: 0px 10px;
  color: white;
  background-color: rgba(255,255,255,0.05);
  border-radius: 5px;
  box-shadow: rgba(0,0,0,0.05) 0 54px 55px,
  rgba(0,0,0,0.05) 0 -12px 30px,
  rgba(0,0,0,0.05) 0 4px 6px,
  rgba(0,0,0,0.05) 0 12px 3px,
  rgba(0,0,0,0.05) 0 -3px 5px;
}

.chat-input-field {
    width: 100%;
  font-size: larger;
  flex-grow: 1;
  padding: 10px;
  border: none;
  border-radius: 5px;
  margin-right: 10px;
  color: white;
  background-color: transparent;
  text-decoration: none;
  outline: none; 
  border-color: transparent;

}
.chat-input-field :focus{
    border-color: transparent;
}

.chat-submit-button {
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 8px !important;
  margin: 5px !important;
  cursor: pointer;
  font-size: 30px;
  margin-left: 10px; 
}

.chat-submit-button:hover {
  background-color: rgba(255, 255, 255, 0.05);
}
.info{
    color: rgba(255,255,255,0.5);
    font-size: 11px;
}

.feed{
    width: 85%;
    padding: 0px;
    height: 100%;
    overflow:auto;
}
.feed:hover{
    scroll-behavior: smooth;
}

.feed>li{
    display: flex;
    padding: 10px;
    margin: 5px 0px;
}

.user-chat {
    justify-content: flex-end;
    text-align: right;
}

.ai-chat {
    justify-content: flex-start;
    text-align: left;
    background-color: #444654;
    border-radius: 5px;
}

@media screen and (max-width: 450px){
    .chat-input-field {
      padding: 10px; 
    }
  
    .chat-submit-button {
      margin-top: 10px;
    }
  }
.aTagSub{
    color: rgb(220, 63, 63);
}
@media only screen and (max-width: 550px) {
  .Main{
      width: 100%;
  }
  .chat-input-container{
    width: 95%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Main/Main.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB;;;;6BAI2B;AAC7B;;AAEA;IACI,WAAW;EACb,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EACb,yBAAyB;;AAE3B;AACA;IACI,yBAAyB;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;AACA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;IAClB;EACF;AACF;IACI,uBAAuB;AAC3B;AACA;EACE;MACI,WAAW;EACf;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".Main{\n    height: 100vh;\n    width: 85%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    text-align: center;\n}\n.bottom_section{\n    width: 80%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n/* ChatInput.css */\n.chat-input-container {\n  width: 90%;\n  display: flex;\n  align-items: center;\n  padding: 0px 10px;\n  color: white;\n  background-color: rgba(255,255,255,0.05);\n  border-radius: 5px;\n  box-shadow: rgba(0,0,0,0.05) 0 54px 55px,\n  rgba(0,0,0,0.05) 0 -12px 30px,\n  rgba(0,0,0,0.05) 0 4px 6px,\n  rgba(0,0,0,0.05) 0 12px 3px,\n  rgba(0,0,0,0.05) 0 -3px 5px;\n}\n\n.chat-input-field {\n    width: 100%;\n  font-size: larger;\n  flex-grow: 1;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  margin-right: 10px;\n  color: white;\n  background-color: transparent;\n  text-decoration: none;\n  outline: none; \n  border-color: transparent;\n\n}\n.chat-input-field :focus{\n    border-color: transparent;\n}\n\n.chat-submit-button {\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 8px !important;\n  margin: 5px !important;\n  cursor: pointer;\n  font-size: 30px;\n  margin-left: 10px; \n}\n\n.chat-submit-button:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n.info{\n    color: rgba(255,255,255,0.5);\n    font-size: 11px;\n}\n\n.feed{\n    width: 85%;\n    padding: 0px;\n    height: 100%;\n    overflow:auto;\n}\n.feed:hover{\n    scroll-behavior: smooth;\n}\n\n.feed>li{\n    display: flex;\n    padding: 10px;\n    margin: 5px 0px;\n}\n\n.user-chat {\n    justify-content: flex-end;\n    text-align: right;\n}\n\n.ai-chat {\n    justify-content: flex-start;\n    text-align: left;\n    background-color: #444654;\n    border-radius: 5px;\n}\n\n@media screen and (max-width: 450px){\n    .chat-input-field {\n      padding: 10px; \n    }\n  \n    .chat-submit-button {\n      margin-top: 10px;\n    }\n  }\n.aTagSub{\n    color: rgb(220, 63, 63);\n}\n@media only screen and (max-width: 550px) {\n  .Main{\n      width: 100%;\n  }\n  .chat-input-container{\n    width: 95%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
